import { Route, Routes, Navigate } from "react-router-dom";
import Footer from "./components/footer/Footer";
import Header from "./components/header/navbar/Header";
import About from "./pages/about/About";
import Dashboard from "./pages/admin/Dashboard";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import CreateDoctor from "./pages/doctors/create-doctor/CreateDoctor";
import Doctor from "./pages/doctors/Doctor";
import Home from "./pages/home/Home";
import { ToastContainer } from "react-toastify";
import DoctorDetails from "./pages/doctors/doctor-details/DoctorDetails";
import Profile from "./pages/profile/Profile";
import UsersTable from "./pages/admin/UsersTable";
import DepartmentTable from "./pages/admin/DepartmentTable";
import CommentsTable from "./pages/admin/CommentsTable";
import DoctorsTable from "./pages/admin/DoctorsTable";
import NotFound from "./pages/not-found-page/NotFound";
import { useSelector } from "react-redux";
import VerifyEmail from "./pages/verify-email/VerifyEmail";
import CityTable from "./pages/admin/CitiesTable";

function App() {
  const user = useSelector((state) => state.auth.user);
  return (
    <>
      <ToastContainer />
      <Header />
      <Routes>
        {/*Public Routes  */}
        <Route
          path="/login"
          element={!user ? <Login /> : <Navigate to="/" />}
        />
        <Route
          path="/register"
          element={!user ? <Register /> : <Navigate to="/" />}
        />
        <Route
          path="/users/:userId/verify/:token"
          element={!user ? <VerifyEmail /> : <Navigate to="/" />}
        />
        <Route path="/" element={<Home />} />
        <Route path="/doctors" element={<Doctor />} />
        <Route path="/doctors/details/:id" element={<DoctorDetails />} />
        <Route
          path="/create"
          element={user ? <CreateDoctor /> : <Navigate to="/" />}
        />
        <Route path="/about" element={<About />} />
        <Route path="/profile/:id" element={<Profile />} />

        {/*Admin Routes */}
        <Route path="admin-dashboard">
          <Route
            index
            element={user?.isAdmin ? <Dashboard /> : <Navigate to="/" />}
          />
          <Route
            path="users-table"
            element={user?.isAdmin ? <UsersTable /> : <Navigate to="/" />}
          />
          <Route
            path="doctors-table"
            element={user?.isAdmin ? <DoctorsTable /> : <Navigate to="/" />}
          />
          <Route
            path="categories-table"
            element={user?.isAdmin ? <DepartmentTable /> : <Navigate to="/" />}
          />
          <Route
            path="comments-table"
            element={user?.isAdmin ? <CommentsTable /> : <Navigate to="/" />}
          />
          <Route
            path="cities-table"
            element={user?.isAdmin ? <CityTable /> : <Navigate to="/" />}
          />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
